import React from 'react';
import moment from 'moment';
import { truncate } from '../../../helpers';
import { getConfig } from '../../../utils/config';
import { useHistory } from 'react-router-dom';
import { winnreAuth, winnreNoAuth } from '../../../utils/axios';
import { useSelector } from 'react-redux';
import useHomeBlogs from '../BlogLayoutVertical1/data';

function BlogLayoutList1({
    className,
    classNameContainer,
    titleClass,
    summaryClass,
    buttonClass,
    bgColors
}) {
    const config = getConfig();
    const { blogs } = useHomeBlogs();
    const history = useHistory();

    const clientWebview = useSelector((state) => state.webView.clientWebview);
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const clickThroughMobile = clientWebview || internalWebview;

    const isUserAuthenticated = useSelector(
        (state) => state.auth.isAuthenticated
    );
    const userId = useSelector((state) => state.auth.userId);
    const blogClickedHandler = (blogId, visibleToAll) => {
        if (isUserAuthenticated) {
            winnreAuth({
                method: 'POST',
                url: `winnre/user/blogs/trackClick?blogId=${blogId}&userId=${userId}&sourcePlatform=${
                    clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                }`
                // headers: headers2
            })
                .then(() => {})
                .catch(() => {});
        } else {
            winnreNoAuth({
                method: 'POST',
                url: `winnre/user/blogs/trackClick?blogId=${blogId}&sourcePlatform=${
                    clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                }`
            })
                .then(() => {})
                .catch(() => {});
        }
        if (visibleToAll) {
            history.push(`/blogs/${blogId}`);
        } else {
            history.push(`/blogs`);
        }
    };

    return (
        <div
            className={
                className
                    ? className
                    : 'w-full h-auto flex flex-col-reverse lg:flex-row justify-center '
            }
        >
            <div
                className={
                    classNameContainer
                        ? classNameContainer
                        : 'w-full flex flex-col lg:flex-row  text-white bg-primary '
                }
            >
                <div className="w-full ">
                    {blogs?.slice(0, 3).map((blog, index) => (
                        <div
                            className={`flex flex-col-reverse ${
                                bgColors && bgColors[index % bgColors?.length]
                            } ${
                                index % 2
                                    ? 'lg:flex-row-reverse'
                                    : 'lg:flex-row'
                            } ${index == 2 && 'flex-col'} `}
                        >
                            <div
                                key={blog.id}
                                className="flex flex-col justify-center px-6 md:px-8 xl:px-16 py-16 lg:py-5 lg:w-[50%] space-y-5"
                            >
                                <h2
                                    className={` ${config?.fontHeading} ${
                                        titleClass ||
                                        'font-Gotham_Light  text-[25px] 3xl:text-[30px] font-medium uppercase leading-[1] break-words text-white'
                                    }`}
                                >
                                    {blog?.heading}
                                </h2>
                                <p
                                    className={`${config?.fontBody} ${
                                        summaryClass ||
                                        'font-Gotham_Light  text-[15px] font-medium  leading-1 break-words text-white'
                                    }`}
                                >
                                    {blog.summary}
                                </p>
                                <button
                                    className={`${config?.fontBody} ${
                                        buttonClass ||
                                        ' text-white py-1 px-4 md:py-2 md:px-4 bg-primary'
                                    }`}
                                    onClick={() =>
                                        blogClickedHandler(
                                            blog.id,
                                            blog.visibleToAll
                                        )
                                    }
                                >
                                    READ MORE
                                </button>
                            </div>
                            <div className="lg:w-[50%] h-[35vh] 2xl:h-[50vh]">
                                <img
                                    src={blog?.displayImageUrl}
                                    alt={blog?.heading}
                                    className="w-full h-full object-cover object-center"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default BlogLayoutList1;
